<template>
  <v-menu
    bottom
    left
    offset-y
    :close-on-content-click="false"
    max-width="360"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="editor-format-info__button"
        icon
        small
        color="secondary"
        aria-label="Show editor format"
        title="Show editor format"
      >
        <v-icon small>mdi-information-outline</v-icon>
      </v-btn>
    </template>

    <v-card class="editor-format-info">
      <v-card-title class="editor-format-info__title">
        Expected format
      </v-card-title>
      <v-card-text class="editor-format-info__content">
        {{ format }}
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    name: 'EditorFormatInfo',
    props: {
      format: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped>
  .editor-format-info__button {
    margin: 0;
  }

  .editor-format-info__title {
    padding: 12px 16px 8px;
    font-family: var(--ims-font-heading);
    font-size: 14px;
    font-weight: 700;
  }

  .editor-format-info__content {
    padding: 0 16px 16px;
    color: var(--ims-color-ink);
    font-family: var(--ims-font-body);
    font-size: 13px;
    line-height: 1.5;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// EditorFormatInfo.vue?597a2a56